import cx from 'classnames';
import { Component, h, VNode } from 'preact';

import PartyPill from './PartyPill';

interface Props {
  ballotName: string;
  candidateId: string;
  contestIsCalled: boolean;
  isIncumbent: boolean;
  isWinner: boolean;
  party: string;
  totalVotesInContest: number;
  votes: number;
}

class CandidateRow extends Component<Props> {
  static Header: VNode;
  static countyHeader: VNode;
  static columnCount: number;

  render() {
    const {
      ballotName,
      isIncumbent,
      isViewable,
      candidateColor,
      party,
    } = this.props;

    let divStyle;

    if (candidateColor) {
      divStyle = {
        'background-color': candidateColor,
      };
    }

    let rowClass = cx('candidate', 'contest__candidate-row');

    if (!isViewable) {
      rowClass += ' race__candidate-row--hidden';
    }

    return (
      <tr class={rowClass}>
        <td class="candidate__cell candidate__party">
          {!candidateColor && <PartyPill party={party} />}
          {candidateColor && <PartyPill party={party} style={divStyle} />}
        </td>
        <th class="candidate__cell candidate__name">
          {ballotName}{' '}
          {isIncumbent && (
            <span class="pill pill--basic" title="Currently holds this seat">
              Incumbent
            </span>
          )}
        </th>
      </tr>
    );
  }
}

CandidateRow.defaultProps = {
  contestIsCalled: false,
  isViewable: true,
};

CandidateRow.Header = (
  <thead>
    <tr>
      <th class="contest__candidate-header" colSpan={2}>
        Candidates
      </th>
    </tr>
  </thead>
);

CandidateRow.countyHeader = (
  <thead>
    <tr>
      <th class="contest__candidate-header" colSpan={2}>
        Candidates
      </th>
    </tr>
  </thead>
);

CandidateRow.columnCount = 2;

export default CandidateRow;

